export const ResourceKeyRegex = /^[a-zA-Z_\-0-9]{1,}$/;
